import moment from "moment-timezone";
import dateFnsFormat from "date-fns/format";
import { FEINPrefixLookup } from "../../data/schema/shared/FEINPrefixLookup";
import util from "../Utils/mappers";
import globalUtil from "../../global/utils/Helpers";

import { wageMultiplier, rateMapper } from "./utils/wageUtils";

const monthYearRegEx = /[\d]{2}\/[\d]{4}/;
const validMonthRegEx = /(0[1-9])|(1[012])/;

// UTILS
const matchRegex = (value, regex) => {
  if (value && value != undefined) {
    if (typeof value === "object") {
      value = value[0];
    }
    if (value !== undefined) {
      return value.match(regex);
    }
  }
};

const isRequiredx2 = (field, message, allValues, extraData) => (value) => {
  if (
    allValues[field[0]] == extraData.valueOf[0] &&
    allValues[field[1]] == extraData.valueOf[1]
  ) {
    if (!value || value == "- Select -") return message;
  }
};

const cannotContain = (characters) => (value) => {
  for (var i = 0; i < characters.length; i++) {
    if (value.indexOf(characters[i]) > -1) {
      const message = `Field cannot contain "${characters[i]}".`;
      return message;
    }
  }
  return undefined;
};

let check = (value, regex, message) => {
  if (value === undefined || value === null) {
    return undefined;
  }
  return matchRegex(value, regex) ? undefined : message;
};
let checkValue = (value, message) =>
  value && value !== "NO" && value !== "N/A"
    ? undefined
    : "This field is required.";

let generateMessage = (args, regex, defaultMessage = "error") => {
  const data = args[0];
  switch (typeof data) {
    case "string":
    case "undefined":
      let value = data;
      return check(value, regex, defaultMessage);
    default:
      let message = data && data.message;
      message = message === undefined ? defaultMessage : message;
      return check(value, regex, message);
  }
};

// START VALIDATION FUNCTIONS
const required = (value) => {
  if (typeof value == "number" && value === 0) {
    value = "0";
  }
  if (value) {
    if (value instanceof Date) {
      return !isNaN(value) ? undefined : "This field is required.";
    } else if (typeof value === "object" && value.label && value.value) {
      return undefined;
    } else if (typeof value === "object") {
      return value.length > 0 || value[0] != undefined
        ? undefined
        : "This field is required.";
    }
    // Trimiing empty white Spaces:
    if (typeof value === "string") {
      value = value.trim();
    }
  }
  return value && value !== "- Select -"
    ? undefined
    : "This field is required.";
};

const requiredIfNotNA = (field, message, allValues, extraData) => (value) => {
  const valueToCheck = allValues[field];
  if (!!valueToCheck) {
    const na_regex = /[Nn]\/[Aa]/g;
    return matchRegex(valueToCheck, na_regex) || !!value ? undefined : message;
  }
  return undefined;
};

const isRequired = (field, message, allValues, extraData) => (value) => {
  let valueToCompare = extraData?.isInlineModal
    ? allValues.add_values_field?.[0]?.[field]
    : allValues[field];

  if (typeof value == "number" && value === 0) {
    value = "0";
  }
  if (extraData?.prefix && extraData?.modal) {
    valueToCompare =
      allValues &&
      allValues[extraData.prefix] &&
      allValues[extraData.prefix][0] &&
      allValues[extraData.prefix][0][field];
  }

  if (!!extraData?.emptyArray) {
    return !!value?.length ? undefined : message;
  }

  if (
    (valueToCompare &&
      (valueToCompare === extraData?.valueOf ||
        (Array.isArray(extraData?.valueOf) &&
          extraData?.valueOf.includes(valueToCompare)))) ||
    extraData?.check === "ifValueExists"
  ) {
    if (!value) {
      value = "";
    }
    if (typeof value === "string") {
      value = value.trim();
    }
    if (value instanceof Date) {
      return !isNaN(value) ? undefined : message;
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        return value.length > 0 || value[0] != undefined ? undefined : message;
      }
      return !!Object.keys(value).length ? undefined : message;
    }
    return value && value !== "- Select -" ? undefined : message;
  }
};

const isNotRequired = (field, message, allValues, extraData) => (value) => {
  let valueToCompare = allValues[field];
  if (typeof valueToCompare == "number" && valueToCompare === 0) {
    valueToCompare = "0";
  }

  if (valueToCompare && valueToCompare !== extraData.valueOf) {
    return valueToCompare !== extraData.valueOf && !value
      ? "This field is required."
      : undefined;
  }
};

// section_f
const select_required = (value) => {
  return !value || (value && (value == "- Select -" || value == ""))
    ? "This field is required"
    : undefined;
};

const requiredWithCustomMessage = (message) => (value) => {
  if (value) {
    if (typeof value === "object") {
      return value.length > 0 || value[0] != undefined ? undefined : message;
    }
    // Trimiing empty white Spaces:
    if (typeof value === "string") {
      value = value.trim();
    }
  }
  return value && value !== "- Select -" && value !== "NO"
    ? undefined
    : message;
};

const required_county =
  (state_name, parent_machine_name = undefined, allValues, extraData) =>
  (value) => {
    let lookup_state = parent_machine_name
      ? allValues &&
        allValues[parent_machine_name] &&
        allValues[parent_machine_name][0] &&
        allValues[parent_machine_name][0][state_name]
      : allValues[state_name];

    let { counties } = extraData;
    if (!counties) {
      // if request to mapper fails then display required message
      return "This field is required.";
    }
    let county_options = counties[lookup_state];
    if (county_options && county_options.length > 0) {
      if (
        value &&
        value.hasOwnProperty("label") &&
        value.hasOwnProperty("value")
      ) {
        return undefined;
      } else return "This field is required.";
    } else {
      return undefined;
    }
  };

const notAnyOf = (arr, message) => (value) => {
  if (value && arr.indexOf(value) !== -1) {
    return message;
  }
  return undefined;
};

const file_required = (value) => {
  const message = "Document upload is required.";
  return value && value.length > 0 ? undefined : message;
};

const number = (value) => {
  let _val;
  if (typeof value === "string") {
    _val = value.trim();
  } else {
    _val = value;
  }
  if (
    _val === undefined ||
    _val === null ||
    _val === "" ||
    (_val && !isNaN(_val))
  ) {
    return undefined;
  } else {
    return "This field must be numeric.";
  }
};

// i.e => validate: [{minLength: 10, message: 'Custom Error Messge Goes here!'}]
const minLength =
  (
    min,
    message = `This field needs to be at least ${min} characters long.`, // default message if no message is passed in
    tableIndex = undefined
  ) =>
  (value) => {
    if (value === undefined || value === null) {
      return undefined;
    }
    // if (value.match(/^N\/A$/i)) {
    //   return undefined;
    // }
    return value.trim().length >= min || value.trim().length === 0
      ? undefined
      : message;
  };

// i.e => validate: [{maxLength: 10, message: 'Custom Error Messge Goes here!'}]
const maxLength =
  (
    max,
    message = `This field cannot be more than ${max} digits long.` // default message if no message is passed in
  ) =>
  (value) => {
    if (value === undefined || value === null) {
      return undefined;
    }
    return value && value.length > max ? message : undefined;
  };

// i.e => validate: [{minValue: 10, message: 'Custom Error Messge Goes here!'}]
const minValue =
  (
    min,
    message = `Should be greater than ${min}`, // default message if no message is passed in
    allValues,
    extraData
  ) =>
  (value) => {
    if (value === undefined || value === null || value === "") {
      return undefined;
    }
    if (
      typeof extraData === "object" &&
      !!extraData?.valueOf &&
      !allValues[extraData.valueOf]
    ) {
      return undefined;
    }
    min =
      extraData && extraData.valueOf && allValues
        ? Number(allValues[extraData.valueOf])
        : min;
    value = Number(value);

    return isNaN(value) || value >= min ? undefined : message;
  };

// i.e => validate: [{minValue: 10, message: 'Custom Error Messge Goes here!'}]
const maxValue =
  (
    max,
    message = `Should be Less than ${max}`, // default message if no message is passed in
    allValues,
    extraData
  ) =>
  (value) => {
    if (value === undefined || value === null) {
      return undefined;
    }
    if (
      typeof extraData === "object" &&
      !!extraData?.valueOf &&
      !allValues[extraData.valueOf]
    ) {
      return undefined;
    }
    value = Number(value);
    value = Number(value);
    max =
      extraData && extraData.valueOf && allValues
        ? Number(allValues[extraData.valueOf])
        : max;
    return isNaN(value) || isNaN(max) || value <= max ? undefined : message;
  };

const compareStringValue =
  (compareStringValue, message, extraData) => (value) => {
    const operator =
      extraData && extraData.operator ? extraData.operator : undefined;
    //default is ===
    if (operator === "!==") {
      return value !== compareStringValue ? message : null;
    } else {
      return value === compareStringValue ? message : null;
    }
  };

const email =
  (...args) =>
  (value) => {
    const trimmedValue = value?.trim();
    if (
      trimmedValue === undefined ||
      trimmedValue === null ||
      trimmedValue === ""
    ) {
      return undefined;
    }
    const allowNAs =
      args && args[0] && args[0].extraData && args[0].extraData.allowNAs;
    // const onlyOne =
    //   args && args[0] && args[0].extraData && args[0].extraData.onlyOne;
    let defaultMessage = "This is not a valid Email Address.";
    let email_regex = "[A-Z0-9'&!#|._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,30}";
    let na_regex = "([Nn]/[Aa])$|";
    // Regex for multiple email addresses in email field
    // Disabled until further notice
    // let lookahead_regex = !onlyOne ? "(?: +" + email_regex + ")*" : "";
    // let regex = new RegExp(
    //   (onlyOne ? "^(" : "") + "^" + (allowNAs ? na_regex : "") + "^" + email_regex + lookahead_regex + "$" + (onlyOne ? ")$" : ""),
    //   "i"
    // );
    let regex = new RegExp(
      "^" + (allowNAs ? na_regex : "") + "^" + email_regex + "$",
      "i"
    );

    return check(trimmedValue, regex, defaultMessage);
  };

const phone = (...args) => {
  let defaultMessage = "This is not a valid Telephone Number.";
  let regex =
    /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/i;

  return check(args[0], regex, defaultMessage);
};

const url =
  (...args) =>
  (value) => {
    const allowNAs = args?.[0]?.extraData?.allowNAs;
    const urlRegex =
      "(https?://)?(www\\.)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\\.[a-z]{2,30}(:[0-9]{1,5})?(/.*)?";
    const na_regex = "([Nn]/[Aa])$|";

    const regex = new RegExp(
      "^" + (allowNAs ? na_regex : "") + "^" + urlRegex + "$",
      "gi"
    );
    let defaultMessage = "This is not a valid Website URL.";
    return check(value, regex, defaultMessage);
  };

const postal = (...args) => {
  let defaultMessage = "This is not a valid Postal Code.";
  if (args[0] === undefined || args[0] === null || args[0] === "") {
    return undefined;
  }
  const regex = /^[A-Za-z0-9-]{4,10}$/i;
  return generateMessage(args, regex, defaultMessage);
};

const postalUSA = (...args) => {
  let defaultMessage = "This is not a valid Postal Code.";
  if (args[0] === undefined || args[0] === null || args[0] === "") {
    return undefined;
  }
  const regex = /^[0-9]{5}(?:-?[0-9]{4})?$/i;
  return generateMessage(args, regex, defaultMessage);
};

const postalCompareValue =
  (
    codeArr,
    message = `This postal code is not valid in the Northern Mariana Islands.`
  ) =>
  (value) => {
    let newCodes;

    if (value === undefined || value === null) return undefined;

    if (Array.isArray(codeArr) && codeArr?.length > 0) newCodes = [...codeArr];

    if (newCodes.includes(value)) return undefined;
    else return message;
  };

const postalCountry =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      allValues === undefined
    ) {
      return undefined;
    }

    let args = [value];
    let defaultMessage = "This is not a valid Postal Code.";
    let regex = /^[A-Za-z0-9-]{0,10}$/i;
    let countryVal =
      extraData && extraData.valueOf && allValues[extraData.valueOf];
    if (extraData.prefix && extraData.modal) {
      countryVal =
        extraData &&
        extraData.valueOf &&
        allValues[extraData.prefix][0][extraData.valueOf];
    }
    if (countryVal === "UNITED STATES OF AMERICA") {
      regex = /^[0-9]{5}(?:-?[0-9]{4})?$/i;
    } else {
      if (extraData?.allowNAs) {
        regex = /(^[A-Za-z0-9- ]{0,10}$)|(^N\/A)/i;
      } else {
        regex = /(^[A-Za-z0-9- ]{0,10}$)/i;
      }
    }

    return generateMessage(args, regex, defaultMessage);
  };

const pNumberCheck = (value) => {
  const message = "Format of P number should be: P-000-00000-000000.";
  const firstLetter = value && value[0].toUpperCase();
  const hyphens = [value && value[1], value && value[5], value && value[11]];
  const numbers = [
    value && value[2],
    value && value[3],
    value && value[4],
    value && value[6],
    value && value[7],
    value && value[8],
    value && value[9],
    value && value[10],
    value && value[12],
    value && value[13],
    value && value[14],
    value && value[15],
    value && value[16],
    value && value[17],
  ];
  const isHyphens = (character) => {
    return character === "-";
  };
  const isNan = (character) => {
    Number(character);
    return !isNaN(character);
  };

  if (
    firstLetter !== "P" ||
    (hyphens && !hyphens.every(isHyphens)) ||
    (numbers && !numbers.every(isNan))
  ) {
    return message;
  }
  return undefined;
};

const fein = (value) => {
  const message = `FEIN numbers can not begin with two zeros.`;
  let fein_str = value ? value.toString() : null;
  if (value === undefined || value === null || value === "") {
    return undefined;
  }
  return value &&
    fein_str &&
    !(fein_str.charAt(0) === "0" && fein_str.charAt(1) === "0")
    ? undefined
    : message;
};

const noNAs = (value) => {
  const na_regex = /[Nn]\/[Aa]/g;
  if (value === undefined || value === null) {
    return undefined;
  }
  return value && !matchRegex(value, na_regex)
    ? undefined
    : `This field does not accept 'N/A's`;
};

const lessThanField =
  (field, message, allValues, tableIndex = undefined) =>
  (value) => {
    if (
      value === undefined ||
      value === null ||
      allValues === undefined ||
      allValues[field] === undefined
    ) {
      return undefined;
    }
    return parseInt(value) <= parseInt(allValues[field]) ? undefined : message;
  };

const isDayOfTheWeek =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    const dayOfWeekLookup = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
    };
    if (!!extraData) {
      const { validateWhen } = extraData;
      if (!Array.isArray(validateWhen)) {
        const fieldName = validateWhen?.fieldName;
        const is = validateWhen?.is;
        if (!allValues[fieldName] || allValues[fieldName] !== is) {
          return undefined;
        }
      }
    }

    return dayOfWeekLookup[field.toLowerCase()] !== moment(value).day()
      ? message
      : undefined;
  };

const dateComparison =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    const { operator, validateWhen } = extraData;
    const valueToCheck = allValues[field];

    if (!valueToCheck) return undefined;
    if (!!extraData) {
      if (!Array.isArray(validateWhen)) {
        const fieldName = validateWhen?.fieldName;
        const is = validateWhen?.is;
        if (!allValues[fieldName] || allValues[fieldName] !== is) {
          return undefined;
        }
      } else {
        let continueValidation = true;
        validateWhen.forEach((when) => {
          const { fieldName, is } = when;
          if (!allValues[fieldName] || allValues[fieldName] !== is) {
            continueValidation = false;
          }
        });
        if (!continueValidation) {
          return undefined;
        }
      }

      let isValid = true;
      switch (operator) {
        case "!==":
          isValid = !moment(value).isSame(valueToCheck);
          break;
        default:
          break;
      }

      return !isValid ? message : undefined;
    }
    return undefined;
  };

const monthYear =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    if (!value) {
      return undefined;
    }
    return matchRegex(value, monthYearRegEx) ? undefined : message;
  };

const validMonth =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    if (!value) {
      return undefined;
    }
    const month = value.split("/")[0];
    return matchRegex(month, validMonthRegEx) ? undefined : message;
  };

const dateIsBefore =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    const { unit, amount } = extraData;
    const minDate = moment().startOf("day").subtract(amount, unit);

    if (!value) {
      return undefined;
    }

    if (moment(new Date(value)).startOf("day").isBefore(minDate)) {
      return message ?? "Invalid date";
    }
    return undefined;
  };

const dateStartCheck =
  (
    field,
    message,
    allValues,
    {
      // This is the extraData object passed in schema
      lessThanValue,
      greaterThanValue,
      emergencyField = undefined,
      emergencyGreaterThanValue,
      emergencyLessThanValue,
      herdingField = undefined,
      herdingGreaterThanValue,
      herdingLessThanValue,
      validateWhen,
      prior,
    },
    tableIndex = undefined
  ) =>
  (field) => {
    if (!!validateWhen && allValues[validateWhen.field] !== validateWhen.is) {
      return undefined;
    }

    let isEmergency = false;
    let isHerding = false;
    if (emergencyField) {
      isEmergency = allValues[emergencyField] === "YES" ? true : false;
    }
    if (herdingField) {
      isHerding = allValues[herdingField] === "YES" ? true : false;
    }
    // comes in as full date, convert to iso format
    const formattedField = dateFnsFormat(new Date(field ?? null), "yyyy-MM-dd");
    // clear out times, get start of day
    let date = moment(new Date(formattedField + "T00:00:00")).startOf("day");
    // ensure start of day is EST
    let estDate = moment.utc(date).tz("America/New_York");
    // ensure comparison "now" is EST
    let estNow = moment.tz(new Date(), "America/New_York").startOf("day");
    let difference = Math.round(estDate.diff(estNow, "days", true));
    if (!!prior) {
      difference = Math.round(estNow.diff(estDate, "days", true));
    }

    // Feb 4 2023 H2-A revision; Feb month is 1
    // let h_2_a_revision_date = moment.utc(moment(new Date(2023, 1, 4))).tz("America/New_York");
    // let difference_revision =  Math.round(h_2_a_revision_date.diff(estDate,"days", true));

    // if(isHerding && difference_revision <= herdingLessThanValue){
    //   return message;
    // }

    if (
      !isEmergency &&
      !isHerding &&
      (difference > greaterThanValue || difference < lessThanValue)
    ) {
      return message;
    } else if (
      isEmergency &&
      !isHerding &&
      (difference > emergencyGreaterThanValue ||
        difference < emergencyLessThanValue)
    ) {
      return message;
    } else if (
      isHerding &&
      !isEmergency &&
      (difference > herdingGreaterThanValue ||
        difference <= herdingLessThanValue)
    ) {
      return message;
    } else if (isHerding && isEmergency) {
      return undefined;
    } else if (
      !herdingField &&
      isEmergency &&
      difference < emergencyLessThanValue
    ) {
      return message;
    } else {
      return undefined;
    }
  };

const dateStartEnd =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    const { validateWhen, customDateFormat } = extraData;
    let start, end, diff;
    let currentValue = value;
    let fieldValueToBeChecked = allValues[field];
    tableIndex = extraData.isModal ? 0 : tableIndex;

    if (!!validateWhen && allValues[validateWhen.field] !== validateWhen.is) {
      return undefined;
    }

    // If tableInput, then set the values:
    if (extraData && extraData.prefix) {
      let tableValue = allValues[extraData.prefix];

      if (
        tableValue[tableIndex] &&
        tableValue[tableIndex][extraData.currentField]
      ) {
        currentValue = tableValue[tableIndex][extraData.currentField];
      }
      if (tableValue[tableIndex] && tableValue[tableIndex][field]) {
        fieldValueToBeChecked = tableValue[tableIndex][field];
      }
    }

    if (currentValue && fieldValueToBeChecked) {
      switch (extraData.type) {
        case "start":
          start = moment(new Date(value));
          end = moment(new Date(fieldValueToBeChecked));
          break;
        case "end":
          start = moment(new Date(fieldValueToBeChecked));
          end = !customDateFormat
            ? moment(new Date(value))
            : moment(value, customDateFormat);
          break;
        default:
          return undefined;
      }
      diff = end.diff(start, "days");
      return diff < 0 ? message : undefined;
    } else {
      return undefined;
    }
  };

const monthYearStartEnd =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    const { validateWhen, isInlineModal } = extraData;
    let start, end, diff;
    let currentValue = value;
    let fieldValueToBeChecked = isInlineModal
      ? allValues.add_values_field?.[0]?.[field]
      : allValues[field];
    tableIndex = extraData.isModal ? 0 : tableIndex;

    if (!!validateWhen && allValues[validateWhen.field] !== validateWhen.is) {
      return undefined;
    }
    // If tableInput, then set the values:
    if (extraData && extraData.prefix) {
      let tableValue = allValues[extraData.prefix];

      if (
        tableValue[tableIndex] &&
        tableValue[tableIndex][extraData.currentField]
      ) {
        currentValue = tableValue[tableIndex][extraData.currentField];
      }
      if (tableValue[tableIndex] && tableValue[tableIndex][field]) {
        fieldValueToBeChecked = tableValue[tableIndex][field];
      }
    }

    if (currentValue && fieldValueToBeChecked) {
      if (
        !matchRegex(currentValue, monthYearRegEx) ||
        !matchRegex(fieldValueToBeChecked, monthYearRegEx)
      ) {
        return undefined;
      }
      const formattedDate = `${currentValue.split("/")[0]}/01/${
        currentValue.split("/")[1]
      }`;
      const formattedFieldValueToBeChecked = `${
        fieldValueToBeChecked.split("/")[0]
      }/01/${fieldValueToBeChecked.split("/")[1]}`;

      switch (extraData.type) {
        case "start":
          start = moment(new Date(formattedDate));
          end = moment(new Date(formattedFieldValueToBeChecked));
          break;
        case "end":
          start = moment(new Date(formattedFieldValueToBeChecked));
          end = moment(new Date(formattedDate));
          break;
        default:
          return undefined;
      }
      diff = end.diff(start, "days");
      return diff < 0 ? message : undefined;
    } else {
      return undefined;
    }
  };

const timeStartEnd =
  (fieldName, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    let begin, end;
    let { type } = extraData;
    switch (type) {
      case "start":
        begin = moment(value, "h:mm a");
        end = moment(allValues[fieldName], "h:mm a");
        return begin.isAfter(end) ? message : undefined;
      case "end":
        end = moment(value, "h:mm a");
        begin = moment(allValues[fieldName], "h:mm a");
        return end.isBefore(begin) ? message : undefined;
      default:
        console.log("Please specify if field is start or end.");
        return undefined;
    }
  };

const tableRequired = (values) => {
  return !values || values.length < 1
    ? ["Please enter in at least one row."]
    : null;
};

const tableRequiredIf =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (values) => {
    let requiredFields = [];
    if (Array.isArray(field)) {
      if (extraData.operator === "||") {
        requiredFields = field.filter(
          (fieldToCheck) => allValues[fieldToCheck] === extraData.valueOf
        );
      } else if (extraData.operator === "&&") {
        let isRequired = true;
        field.map((fieldToCheck, index) => {
          const requiredValue = extraData.valueOf[index];
          const fieldValue = allValues[fieldToCheck];

          if (requiredValue === undefined) {
            if (!!fieldValue?.length) isRequired = false;
          } else if (fieldValue !== requiredValue) {
            isRequired = false;
          }
        });
        if (isRequired) {
          requiredFields = [...requiredFields, true];
        }
      }
      if (!requiredFields?.length) {
        return null;
      }
    } else if (allValues[field] !== extraData.valueOf) {
      return null;
    }

    if (extraData.dynamicMinRows) {
      return !values || values.length < requiredFields.length
        ? [
            `Please enter 
        ${requiredFields.length} ${requiredFields.length > 1 ? "rows" : "row"}. 
        ${message}`,
          ]
        : null;
    }
    return !values || values.length < 1 ? [message] : null;
  };

const Incompletetable = (values) => {
  let rowErrorList = [];
  let rowsIncomplete = values?.filter((v, index) => {
    if (v?.hasOwnProperty("error") && v?.error === true) {
      rowErrorList = [...rowErrorList, index + 1];
      return true;
    }
  });
  if (rowsIncomplete?.length > 0) {
    return [
      `Please ensure all profiles are complete. (Row${
        rowErrorList?.length > 1 ? "s" : ""
      } ${rowErrorList.join(", ")})`,
    ];
  } else {
    return null;
  }
};

/**
 *
 * @param field - field validation is implemented on
 * @param message - message to return in case of error
 * @param allValues - all values currently in the field
 * @param begin_date - start of the date range from another field in the form
 * @param end_date - end of the date range from another field in the form
 * @param prefix - Optional: table machine_name/prefix to fetch data out of array generated in table inputs
 * @param tableIndex - Optional: index of field in addendum tables
 * @returns {Function}
 */
const dateRangeCheck =
  (
    field,
    message,
    allValues,
    {
      begin_date,
      end_date,
      prefix = undefined,
      isModal,
      typeCheck = undefined,
      operator = undefined,
      valueToCompare = undefined,
      condition = undefined,
    },
    tableIndex = undefined
  ) =>
  (value) => {
    tableIndex = isModal ? 0 : tableIndex;

    if (!begin_date || !end_date) {
      return undefined;
    } else {
      let checkDate = "";
      if (prefix) {
        let table = allValues[prefix];
        if (table && table[tableIndex] && table[tableIndex][field]) {
          checkDate = table[tableIndex][field];
        } else {
          return undefined;
        }
      } else {
        checkDate = allValues[field];
      }
      // Check if a condition exists:

      if (checkDate) {
        begin_date = allValues[begin_date];
        end_date = allValues[end_date];
        if (begin_date && end_date) {
          if (moment(checkDate).isBetween(begin_date, end_date, null, "[]")) {
            return undefined;
          } else {
            return message;
          }
        } else {
          return undefined;
        }
      } else {
        return undefined;
      } // end if(checkDate)
    }
  };

/**
 *
 * @param field - machine name of field the validation is being implemented on
 * @param message - error message to display if conditions are not met
 * @param allValues - all Form values keyed by machine name
 * @param notEqual - string or array of value we don't want the field to be
 * @param when - other field whose value we are checking for
 * @param is - the value of the 'when' field we look for to see if otherFieldEqualToCondition will be true
 * @returns error or undefined if validation passes
 */
const fieldNotEqualToWhenOtherFieldIs =
  (field, message, allValues, { notEqual, when, is }) =>
  (value) => {
    if (is && when) {
      const otherFieldEqualToCondition = allValues[when] === is;
      if (otherFieldEqualToCondition) {
        if (typeof notEqual === "object") {
          return notEqual.includes(value) ? message : undefined;
        } else {
          // string
          return value === notEqual ? message : undefined;
        }
      }
    }
    return undefined;
  };

const prevailingWageCheck =
  (
    field,
    message,
    allValues,
    { prevailing_wage, prevailing_wage_per, wage_per }
  ) =>
  (value) => {
    const current_per = rateMapper(allValues[wage_per]);
    const pw_per = rateMapper(allValues[prevailing_wage_per]);
    const pw_wage = allValues[prevailing_wage];

    // For 9089, as pw linking is conditional
    if (wage_per === "jobOppWagePer" && (!current_per || !pw_per || !pw_wage)) {
      return undefined;
    }

    if (
      value === undefined ||
      value === null ||
      current_per === undefined ||
      pw_per === undefined ||
      pw_wage === undefined
    ) {
      return undefined;
    }

    // compare the values as normal
    if (current_per === pw_per) {
      if (!(parseFloat(value) >= globalUtil.parseUSD(pw_wage))) {
        return message;
      } else {
        return undefined;
      }
    } else {
      // scale current value to match the PW where a week is considered 35 hours
      let scaled_wage =
        parseFloat(value) * wageMultiplier[`${current_per}${pw_per}`];

      scaled_wage =
        Math.round(parseFloat((scaled_wage * Math.pow(10, 2)).toFixed(2))) /
        Math.pow(10, 2);

      if (!(Math.round(scaled_wage) >= globalUtil.parseUSD(pw_wage))) {
        const formattedCurrency = Math.round(scaled_wage).toLocaleString(
          "en-US",
          { style: "currency", currency: "USD" }
        );

        return `The value entered scales to ${formattedCurrency} per ${pw_per?.toLowerCase()} which is lower than the Prevailing Wage you specified ($${pw_wage} per ${pw_per?.toLowerCase()})`;
      } else {
        return undefined;
      }
    }
  };

/**
 *
 * @param field - machine name of field the validation is being implemented on
 * @param message - error message to display if conditions are not met
 * @param allValues - all Form values keyed by machine name
 * @param when - other field whose value to see if it's untouched
 * @param is - the  desired value of the current field
 * @returns error or undefined if validation passes
 */
const fieldCompletedWhenOtherFieldIsUntouched =
  (field, message, allValues, { notEqual, when, is }) =>
  (value) => {
    if (
      value === is &&
      (allValues[when] === null || allValues[when] === undefined)
    ) {
      return message;
    } else {
      return undefined;
    }
  };

/**
 *
 * @param field - field itself
 * @param message - error message
 * @param allValues - all current field values
 * @param firstName - names to check
 * @param lastName - names to check
 * @param sourceFirstName - names to check against
 * @param sourceLastName - names to check against
 * @param tableIndex
 */
const uniqueNameCheck =
  (
    field,
    message,
    allValues,
    { firstName, lastName, sourceFirstName, sourceLastName },
    tableIndex = undefined
  ) =>
  (value) => {
    firstName = allValues[firstName];
    lastName = allValues[lastName];
    sourceFirstName = allValues[sourceFirstName];
    sourceLastName = allValues[sourceLastName];
    if (firstName && lastName && sourceFirstName && sourceLastName) {
      if (
        firstName.trim().toUpperCase() + lastName.trim().toUpperCase() ===
        sourceFirstName.trim().toUpperCase() +
          sourceLastName.trim().toUpperCase()
      ) {
        return message;
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  };

const uniqueValueCheck =
  ({ fieldsToCheck }, message, allValues) =>
  (value) => {
    const valueCleaner = (value) => {
      return value?.trim()?.toUpperCase();
    };

    let found = false;

    // Modals work differently: If row is being edited, values are allowed to match itself
    const editedRow = allValues?.["add_values_field"]?.[0]?.["rowNum"];
    found = fieldsToCheck?.some(({ fieldArray, fieldToCheck }) => {
      if (fieldArray) {
        return allValues?.[fieldArray]?.find((row, index) => {
          // Don't value check against itself, so return
          if (editedRow === index) return;

          return valueCleaner(row?.[fieldToCheck]) === valueCleaner(value);
        });
      } else {
        return valueCleaner(allValues[fieldToCheck]) === valueCleaner(value);
      }
    });

    if (found) {
      return message;
    }

    return undefined;
  };

/**
 *
 * @param field - machine name of field the validation is being implemented on
 * @param message - error message to display if conditions are not met
 * @param allValues - all Form values keyed by machine name
 * @param operator - operator to use for comparison (<,>,<=,>=,=,!=,minLength,maxLength)
 * @param valueOf - either the machine name of a field to reference as a max/min value or a hardcoded value
 * @param prefix - table name from schema for in-table validations (optional)
 * @param valueOfPrefix - table name prefix for referencing value of other field in a table (optional)
 * @param tableIndex - row of the table to check for values (optional)
 * @returns error or undefined if validation passes
 */
const fieldComparison =
  (
    field,
    message,
    allValues,
    {
      operator,
      valueOf,
      times = undefined,
      prefix = undefined,
      valueOfPrefix = undefined,
      modal = false,
      valueOfFieldName,
    },
    tableIndex = undefined
  ) =>
  (value) => {
    // Set index to zero if modal
    tableIndex = modal ? 0 : tableIndex;

    // If Default message, if no message is present:
    if (!message) {
      // If Field Name is Provided in the UI:
      if (valueOfFieldName) {
        message = `${allValues[field]} is more than the ${valueOfFieldName}`;
      } else {
        message = `${allValues[field]} is greater than the allowed value of ${allValues[valueOf]}`;
      }
    }
    if (!operator && !valueOf) {
      if (!operator) {
        console.log(`no operator specified for ${field}`);
      } else {
        console.log(`no literal value or field value specified for ${field}`);
      }
      return undefined;
    }
    let fieldVal = undefined;
    if (prefix) {
      let table = allValues[prefix];
      if (table && table[tableIndex] && table[tableIndex][field]) {
        fieldVal = table[tableIndex][field];
      }
    } else if (modal) {
      fieldVal = allValues[prefix][tableIndex][field];
    } else {
      fieldVal = allValues[field];
    }
    let field2Val = undefined;
    if (isNaN(valueOf) && valueOf !== null) {
      if (operator === "minLength" || operator === "maxLength") {
        console.log(
          `string specified for length requirement of ${field}. Expected number`
        );
        return undefined;
      } else {
        if (valueOfPrefix) {
          let table = allValues[valueOfPrefix];
          if (table && table[tableIndex] && table[tableIndex][valueOf]) {
            field2Val = table[tableIndex][valueOf];
          }
        } else {
          field2Val = allValues[valueOf];
        }
      }
    } else {
      field2Val = valueOf;
    }

    // Don't error if there is no value in the field
    if (!fieldVal || !field2Val) {
      return undefined;
    }

    if (operator === "<") {
      if (!(parseFloat(fieldVal) < parseFloat(field2Val))) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === ">") {
      if (!(parseFloat(fieldVal) > parseFloat(field2Val))) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === "<=") {
      if (!(parseFloat(fieldVal) <= parseFloat(field2Val))) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === ">=") {
      if (!(parseFloat(fieldVal) >= parseFloat(field2Val))) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === "=") {
      if (!(parseFloat(fieldVal) === parseFloat(field2Val))) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === "!=") {
      if (parseFloat(fieldVal) === parseFloat(field2Val)) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === "maxLength") {
      if (fieldVal.length > field2Val) {
        return message;
      } else {
        return undefined;
      }
    } else if (operator === "minLength") {
      if (fieldVal.length < field2Val) {
        return message;
      } else {
        return undefined;
      }
    }
  };

/*
Takes in Two field names, and conditions
conditions:
  -'ifValueExists': Make current field required if a value exists for another field
  -'addendumSum': Checks the sum of a fields from field array with another field or value
*/

const valueChecker =
  (currentField, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    let currentFieldValue = allValues[currentField];
    let fieldToCheck = allValues[extraData.valueOf];
    tableIndex = extraData.modal ? 0 : tableIndex;

    if (
      extraData.prefix &&
      allValues[extraData.prefix] &&
      allValues[extraData.prefix][tableIndex] &&
      allValues[extraData.prefix][tableIndex][currentField]
    ) {
      currentFieldValue = allValues[extraData.prefix][tableIndex][currentField];
    }
    // Check to see if a value in another field exists
    if (extraData.check === "ifValueExists") {
      if (extraData && extraData.valueOf && Array.isArray(extraData.valueOf)) {
        let emptyFieldPresent = false;
        let fieldArray = [];
        extraData.valueOf.forEach((field) => {
          if (!allValues[field]) {
            fieldArray.push(field);
            emptyFieldPresent = true;
          }
        });
        if (fieldArray.length !== extraData.valueOf.length) {
          if (emptyFieldPresent && !currentFieldValue) {
            return message;
          }
        }
      } else {
        if (
          !!extraData.modal &&
          !!allValues[extraData?.prefix]?.[tableIndex]?.[extraData?.valueOf]
        ) {
          fieldToCheck =
            allValues[extraData.prefix][tableIndex][extraData.valueOf];
        }
        if (
          fieldToCheck !== undefined &&
          (currentFieldValue === undefined ||
            currentFieldValue === "- Select -")
        ) {
          return message;
        }
      }
    }
    if (extraData.check === "ifValueEmpty") {
      if (
        fieldToCheck === undefined ||
        fieldToCheck === null ||
        fieldToCheck === ""
      ) {
        return message;
      }
    }
    if (extraData.check === "sumOfFields") {
      let sum;
      let fieldToCheckNum = Number(fieldToCheck);
      if (Array.isArray(extraData.fields)) {
        sum = extraData.fields
          .map((x) => {
            return Math.round(allValues[x]);
          })
          .reduce((total, x) => {
            return total + x;
          });
      }
      switch (extraData.operator) {
        case ">":
          return fieldToCheckNum > sum ? message : undefined;
        case "<":
          return fieldToCheckNum < sum ? message : undefined;
        case "=":
          return fieldToCheckNum === sum ? undefined : message;
        default:
          return undefined;
      }
    }

    let operator;
    // Checking sum of values (i.e 9035 Appendix A )
    if (extraData.check === "fieldArraySum") {
      currentFieldValue = undefined;
      if (
        extraData.fieldArray &&
        extraData.fieldArray.machine_name &&
        allValues[extraData.fieldArray.machine_name]
      ) {
        operator = extraData.operator;
        // Get the fieldArray & fieldName
        const fieldArray = allValues[extraData.fieldArray.machine_name];
        const field = extraData.field;
        let localNumArr = [];
        let sum;

        // Loop through the fieldArray and push the numbers into one array
        fieldArray.forEach((item) => {
          localNumArr.push(item[field]);
          // Sum of values:
          sum = localNumArr.reduce((a, b) => a + b, 0);
        });

        // Reassign some values if doing a singleRow Check
        if (extraData.fieldArray.singleRowCheck && fieldArray.length === 1) {
          message = extraData.fieldArray.message;
          sum =
            allValues[extraData.fieldArray.machine_name][0][extraData.field];
          operator = extraData.fieldArray.operator;
        }

        sum = parseFloat(sum); // sum
        const val2 = parseFloat(allValues[extraData.valueOf]); // value to compare

        // If Valueof don't exist, then throw an error
        if (!val2 || val2 == undefined) {
          message = `Please enter a value for ${extraData.valueOfFieldName}`;
          return message;
        }

        if (sum && sum !== undefined && val2 && val2 != undefined)
          // Add other operators as needed:
          switch (operator) {
            case "!=":
              return sum !== val2 ? message : undefined;
            case ">=":
              return sum >= val2 ? message : undefined;
            case "<=":
              return sum <= val2 ? message : undefined;
            case "<":
              return sum < val2 ? message : undefined;
            case ">":
              return sum > val2 ? message : undefined;

            default:
              return undefined;
          }
      }
    }
  };

const conditionalValueChecker =
  (
    currentField,
    message,
    allValues,
    {
      date = false,
      modal = false,
      valueOf = undefined,
      condition = undefined,
      typeCheck = undefined,
      begin_date = undefined,
      end_date = undefined,
      operator = undefined,
      prefix = undefined,
      valueToCompare = undefined,
    },
    tableIndex = undefined
  ) =>
  (value) => {
    // let currentFieldValue = allValues[currentField];
    // const fiel2Value = allValues[valueOf];
    tableIndex = modal ? 0 : tableIndex;

    // Check the difference of the dates:
    if (condition) {
      const { fieldToCheck, values } = condition;
      const fieldToCheckValue = allValues[fieldToCheck];

      if (fieldToCheck && values && fieldToCheck && fieldToCheckValue) {
        for (let i = 0; i < values.length; i++) {
          if (fieldToCheckValue === values[i]) {
            if (date) {
              if (begin_date || end_date) {
                begin_date = allValues[begin_date];
                end_date = allValues[end_date];
                // build out more typeChecks if necessary
                if (typeCheck === "diff") {
                  const diff = moment(end_date).diff(begin_date, "days");
                  // Build out more operators if necessary:
                  switch (operator) {
                    case ">":
                      return diff > valueToCompare ? message : undefined;
                    case "<":
                      return diff < valueToCompare ? message : undefined;
                    case "=":
                      return diff === valueToCompare ? message : undefined;

                    default:
                      return undefined;
                  }
                }
              } else {
                return undefined;
              }
            }
          } else {
            return undefined;
          }
        }
      }
    }
  };

/**
 *
 * @param field - machine name of field the validation is being implemented on
 * @param message - error message to display if conditions are not met
 * @param allValues - all Form values keyed by machine name
 * @param numRequired - number of the set that is required
 * @param fieldArray - Set of fields to check for values. Can be strings, an array of strings, or a combination of both (new)
 * @returns error or undefined if validation passes
 */
const subsetOfSetRequired =
  (
    field,
    message,
    allValues,
    { numRequired, fieldArray, allowNAs, when, is, to },
    tableIndex = undefined
  ) =>
  (value) => {
    if (!Array.isArray(fieldArray)) {
      return undefined;
    }
    if (isNaN(numRequired)) {
      numRequired = parseInt(numRequired);
    }
    let enteredFields = 0;
    if (when && is && to) {
      switch (is) {
        case "=":
          if (allValues[when] !== to) {
            return false;
          }
          break;
        case "!=":
          if (allValues[when] === to) {
            return false;
          }
          break;
        default:
      }
    }

    // This is for Modal Validation
    if (field == "add_values_field") {
      if (
        allValues &&
        allValues[field] &&
        allValues[field].length > 0 &&
        allValues[field][0] !== undefined
      ) {
        fieldArray.map((fields) => {
          if (
            Object.keys(allValues[field][0]).includes(fields) &&
            allValues[field][0][fields]?.length > 0
          ) {
            enteredFields++;
          }
        });
      }
    } else {
      fieldArray.map((fields) => {
        /**
         * Added functionality for the potential of codependent fields to combine to 1 completed field that enables
         * submission/continue/no error. Please be aware that noNAs are not checked in here. Only the fact that there are values.
         *
         * To use this feature, pass all of the machine names that you want to collate as 1 as an array.
         *
         * Ex. ["machine_1", "machine_2", "machine_3"]
         */
        if (Array.isArray(fields)) {
          let checkAllCodependencyFields = false;
          fields.map((oneField) => {
            if (allValues[oneField]?.length > 0) {
              checkAllCodependencyFields = true;
            } else {
              checkAllCodependencyFields = false;
            }
          });
          if (checkAllCodependencyFields === true) enteredFields++;
        }

        if (allValues[fields]) {
          let isNA = !!matchRegex(
            allValues[fields].toString(),
            /^([Nn]\/[Aa])$/i
          );
          if (!allowNAs && isNA) {
            return false;
          }
          if (!isNaN(fields)) {
            console.log(`improper value passed in fieldArray for ${field}`);
          }
          if (allValues[fields]) {
            enteredFields++;
          }
        }

        return false;
      });
    }
    if (enteredFields < numRequired) {
      return message;
    } else {
      return undefined;
    }
  };

/**
 *
 * @param field
 * @param message
 * @param allValues
 * @param tableIndex
 * @constructor
 */
const FEINPrefixValidator =
  (field, message, allValues, extraData, tableIndex = undefined) =>
  (value) => {
    let prefixes = [];
    Object.keys(FEINPrefixLookup).forEach(function (key) {
      prefixes.push(FEINPrefixLookup[key].EIN_prefix);
    });
    if (
      allValues[field] &&
      prefixes.includes(parseInt(allValues[field].substr(0, 2)))
    ) {
      return undefined;
    } else if (extraData && extraData.condition) {
      let condition = extraData.condition;
      if (allValues[condition.when] != condition.value) {
        return undefined;
      } else {
        return message;
      }
    } else {
      return message;
    }
  };

const fieldArraySumLessThan =
  (notLessThan, message, allValues, { fieldArray, fieldToCheck }) =>
  (fakeValue) => {
    const value = allValues[fieldArray];
    const notLessThanValue = allValues[notLessThan];
    if (!notLessThanValue || !value) {
      return undefined;
    }
    let sum = 0;
    value.map((row) => {
      sum = sum + parseFloat(row[fieldToCheck]);
    });
    if (sum < parseFloat(notLessThanValue)) {
      return message;
    }
    return undefined;
  };

const fieldArrayContainsValue =
  (
    fieldValueToCheck,
    message,
    allValues,
    {
      fieldArray,
      fieldToCheck,
      shouldContainValue = true,
      onlyIf = false,
      operator = false,
    }
  ) =>
  (value) => {
    let runValidation = true;
    if (!fieldValueToCheck || !allValues) {
      return undefined;
    }

    // Only run when criteria is matched
    if (onlyIf && operator) {
      switch (operator) {
        case "===":
          runValidation = value === onlyIf;
          break;
        case "<":
          runValidation = value?.length < onlyIf;
          break;
        default:
          runValidation = false;
      }
    }
    if (runValidation) {
      const fieldArrayValues = allValues?.[fieldArray];
      if (fieldArrayValues || shouldContainValue) {
        const containsValues = fieldArrayValues?.some(
          (obj) => obj?.[fieldToCheck] === fieldValueToCheck
        );
        const valid = containsValues === shouldContainValue;

        if (!valid) {
          return message;
        }
      }
    }

    return undefined;
  };

const fieldArrayContainsOldIndex =
  (index, message, allValues, { fieldArray, fieldToCheck }) =>
  (fakeValue) => {
    let entries = allValues[fieldArray];
    entries = entries.filter(
      (x) =>
        x.f12_f13_f14_prevailing_wage_question === "f13_is_oes_prevailing_wage"
    );
    if (!index || !allValues || !entries) {
      return undefined;
    }
    let expiredEntries = entries.filter((x) => x.f13b_source_year !== index);
    if (expiredEntries && expiredEntries.length > 0) {
      return message;
    }
    return undefined;
  };

/* {
  multiFieldComparison: "",
  extraData:{
    fields: [
      {
        // "is" needs to exist first
        is: "requestorPocLastName",
        this: "=",
        to: "attyLastname",
      },
    ],
  }
  message:
    "The employer point of contact must be different from the agent/attorney, unless the agent/attorney is an employee of the employer.",
}, */
const multiFieldComparison =
  (field, message, allValues, { fields }) =>
  (value) => {
    let valid = true;
    if (fields && allValues) {
      for (let field of fields) {
        if (field.to && field.is && field.this) {
          const fieldIsValue = allValues[field.is];
          const fieldToValue = allValues[field.to];
          switch (field.this) {
            case "=":
              if (fieldIsValue === fieldToValue) {
                valid = false;
              }
              break;
            default:
          }
        }
      }
      if (!valid) {
        return message;
      }
    }

    return undefined;
  };

const totalSalary9035 =
  (field, message, allValues, tableIndex = undefined) =>
  (value) => {
    let errors = [];
    let section_f_values = allValues.section_f;
    if (section_f_values) {
      section_f_values.forEach((row, index) => {
        if (
          row.f10_nonimmigrant_wage_from &&
          row.f10a_nonimmigrant_wage_per &&
          allValues.b4_is_full_time === "YES" &&
          (allValues.h4_exemption_basis === "$60,000 or higher annual wage" ||
            allValues.h4_exemption_basis === "Both")
        ) {
          let per = row.f10a_nonimmigrant_wage_per;
          let wage = parseInt(row.f10_nonimmigrant_wage_from);
          let tot_sal;
          switch (per) {
            case "Hour":
              tot_sal = wage * 2000;
              break;
            case "Week":
              tot_sal = wage * 50;
              break;
            case "Bi-Weekly":
              tot_sal = wage * 25;
              break;
            case "Month":
              tot_sal = wage * 12;
              break;
            default:
              tot_sal = wage;
              break;
          }
          if (tot_sal < 60000) {
            errors.push(index + 1);
          }
        }
      });
      if (errors.length > 0) {
        return `For H-1B workers exempt based on salary or both salary and education, the wage rate in F.a.10 must equal at least $60,000. See row(s) [${errors.join(
          ", "
        )}] in Section F.`;
      } else {
        return undefined;
      }
    }
    return undefined;
  };
//date can not be in the future
const noFutureDate = (value) => {
  const today = moment(moment().format("YYYY-MM-DD"));
  if (!!value) {
    const userValue = moment(moment(value).format("YYYY-MM-DD"));
    if (userValue.isAfter(today)) {
      return "No future date allowed";
    }
  }
  return undefined;
};

const noFutureDateModal =
  (field, message, allValues, { prefix = "add_values_field" }) =>
  (value) => {
    return noFutureDate(allValues[prefix][0][field]);
  };

const noFutureDateTextFields = (value) => {
  if (!value) {
    return undefined;
  }
  var d = value;
  var date = d.split("/");
  var newDate = new Date(date[1], date[0] - 1, 1);
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  if (!!value) {
    const userValue = new Date(newDate)
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    if (userValue > today) {
      return "No future date allowed";
    }
  }
  return undefined;
};

// Year can not be too far in the past or in the future at all.
const noInvalidYear = (value) => {
  if (!value) {
    return undefined;
  }

  const number = Number(value);
  if (number < 1776 || number > moment().year()) {
    return "Invalid Date.";
  }
  return undefined;
};

const minLengthWithNA =
  (
    min,
    message = `This field needs to be at least ${min} characters long.`, // default message if no message is passed in
    tableIndex = undefined
  ) =>
  (value) => {
    if (value === undefined || value === null) {
      return undefined;
    }
    if (value.match(/^N\/A$/i)) {
      return undefined;
    }
    return value.trim().length >= min || value.trim().length === 0
      ? undefined
      : message;
  };

const tripleFieldComparison =
  (field, message, allValues, { fields }) =>
  (value) => {
    let valid = true;
    if (fields && allValues) {
      for (let field of fields) {
        if (field.fieldVal && field.two && field.three) {
          const fieldToValue1 = allValues[field.fieldVal];
          const fieldToValue2 = allValues[field.two];
          const fieldToValue3 = allValues[field.three];
          if (fieldToValue1 != undefined) {
            var fieldValue1 = fieldToValue1.toLowerCase();
          }
          if (fieldToValue2 != undefined) {
            var fieldValue2 = fieldToValue2.toLowerCase();
          }
          if (fieldToValue3 != undefined) {
            var fieldValue3 = fieldToValue3.toLowerCase();
          }
          if (
            fieldToValue1 != null &&
            fieldToValue2 != null &&
            fieldToValue3 != null
          ) {
            switch (field.this) {
              case "=":
                if (
                  fieldValue1 === fieldValue2 &&
                  fieldValue2 === fieldValue3
                ) {
                  valid = false;
                } else if (
                  fieldValue1 === fieldValue2 ||
                  fieldValue1 === fieldValue3
                ) {
                  valid = false;
                } else {
                }
                break;
              default:
            }
          }
        }
      }
      if (!valid) {
        return message;
      }
    }
    return undefined;
  };

// END VALIDATION FUNCTIONS

const getValidator = (name) => {
  const validators = {
    required: required,
    isRequiredx2: isRequiredx2,
    isRequired: isRequired,
    isNotRequired: isNotRequired,
    requiredIfNotNA: requiredIfNotNA,
    select_required: select_required,
    requiredWithCustomMessage: requiredWithCustomMessage,
    required_county: required_county,
    checkValue: checkValue,
    cannotContain: cannotContain,
    compareStringValue: compareStringValue,
    file_required: file_required,
    number: number,
    minLength: minLength, // takes arg
    maxLength: maxLength, // takes arg
    minValue: minValue, // takes arg
    maxValue: maxValue, // takes arg
    lessThanField: lessThanField, // takes arg
    noFutureDate: noFutureDate,
    noFutureDateModal: noFutureDateModal,
    noInvalidYear: noInvalidYear,
    dateIsBefore: dateIsBefore,
    fein: fein,
    noNAs: noNAs,
    email: email,
    phone: phone,
    url: url,
    postal: postal,
    postalUSA: postalUSA,
    postalCompare: postalCompareValue,
    postalCountry: postalCountry,
    pNumberCheck: pNumberCheck,
    dateStartCheck: dateStartCheck,
    dateStartEnd: dateStartEnd,
    timeStartEnd: timeStartEnd,
    fieldComparison: fieldComparison,
    fieldNotEqualToWhenOtherFieldIs: fieldNotEqualToWhenOtherFieldIs,
    fieldCompletedWhenOtherFieldIsUntouched:
      fieldCompletedWhenOtherFieldIsUntouched,
    subsetOfSetRequired: subsetOfSetRequired,
    dateRangeCheck: dateRangeCheck,
    valueChecker: valueChecker, // takes arg
    tableIncomplete: Incompletetable,
    // tableIncompleteIf: IncompletetableIf,
    tableRequired: tableRequired,
    tableRequiredIf: tableRequiredIf,
    FEINPrefixValidator: FEINPrefixValidator,
    totalSalary9035: totalSalary9035,
    fieldArraySumLessThan: fieldArraySumLessThan,
    fieldArrayContainsOldIndex: fieldArrayContainsOldIndex,
    fieldArrayContainsValue: fieldArrayContainsValue,
    prevailingWageCheck: prevailingWageCheck,
    conditionalValueChecker: conditionalValueChecker,
    multiFieldComparison: multiFieldComparison,
    uniqueNameCheck: uniqueNameCheck,
    uniqueValueCheck: uniqueValueCheck,
    notAnyOf: notAnyOf,
    tripleFieldComparison: tripleFieldComparison,
    isDayOfTheWeek: isDayOfTheWeek,
    dateComparison: dateComparison,
    monthYear: monthYear,
    monthYearStartEnd: monthYearStartEnd,
    minLengthWithNA: minLengthWithNA,
    validMonth: validMonth,
    noFutureDateTextFields: noFutureDateTextFields,
  };

  return validators[name];
};

// FIELD VALIDATION ENGINE
/*
    createArgumentsForValidator:

    takes an array called 'validate' that looks like...

    ['required', 'fein', {'min': 10}]

        - strings ( validator takes no arg )
        - objects ( when the validator takes arg )

    ...and turns it into validation functions that we pass to composeValidators

*/

const createArgumentsForValidator = (
  validators,
  allValues,
  tableIndex = undefined,
  counties
) => {
  let args = [];

  validators.map(async (v) => {
    if (typeof v === "string") {
      args.push(getValidator(v));
    } else if (typeof v === "object") {
      // main arg always the first ( and only ) property (if more needed, pass obj)
      let validator_name = Object.keys(v)[0];

      let validator_arg = v[validator_name];

      // message if provided
      let message = v["message"];

      // extraData if provided
      let extraData = v["extraData"];
      if (validator_name === "required_county") {
        if (!extraData) {
          extraData = {};
        }
        if (!counties) {
          try {
            counties = await util.getCounties();
          } catch (e) {
            console.log("could not fetch county data");
          }
        }
        extraData["counties"] = counties;
      }
      // flag for field values
      let needsFieldValues = v["needsFieldValues"] === true;

      let validator = getValidator(validator_name);
      if (needsFieldValues) {
        args.push(
          validator(validator_arg, message, allValues, extraData, tableIndex)
        );
      } else {
        args.push(validator(validator_arg, message, extraData, tableIndex));
      }
    }
  });
  return args;
};

const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    );

const validator = (validators, allValues, tableIndex = undefined, counties) => {
  let args = createArgumentsForValidator(
    validators,
    allValues,
    tableIndex,
    counties
  );
  return composeValidators.apply(undefined, args);
};

export { validator };
